import { render, staticRenderFns } from "./DicomView_abandon.vue?vue&type=template&id=577fa534&scoped=true&"
import script from "./DicomView_abandon.vue?vue&type=script&lang=js&"
export * from "./DicomView_abandon.vue?vue&type=script&lang=js&"
import style0 from "./DicomView_abandon.vue?vue&type=style&index=0&id=577fa534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577fa534",
  null
  
)

export default component.exports